import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaSave, FaBackward, FaThumbsUp, FaThumbsDown, FaPlaneDeparture, FaPlaneArrival } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import { dataMysql, extract } from '../../../util/util';
import ReactSelect from '../../../components/ReactSelect';
import NavItem from '../../../components/NavItem';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import moment from 'moment';
import Alert from '../../../components/Alert';
import { getText, getParticipantLanguage } from '../../../util/translations';

export default function CadastroEventoParticipanteAereoConvite({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem("perfil");
    const [dados, setDados] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [marcadoIda, setMarcadoIda] = useState(null);
    const [cidadeOrigem, setCidadeOrigem] = useState('');
    const [marcadoRetorno, setMarcadoRetorno] = useState(null);
    const [aereoNaoAtendeIda, setAereoNaoAtendeIda] = useState(false);
    const [aereoNaoAtendeVolta, setAereoNaoAtendeVolta] = useState(false);
    const [documentosEntradaPaisCiente, setDocumentosEntradaPaisCiente] = useState(false);
    const history = useHistory();
    let { state } = useLocation();
    //var idEvento = state?.evento ?? null;
    const idioma = dados?.idioma || state?.idioma || null;
    const modeloClienteString = dados.evento?.cliente?.modelo ?? 'master';
    const isSanofiModelo = modeloClienteString === 'sanofi';

    const buscar = () => {
        setIsLoading(true);
        setIsError(false);
        api({
            method: "get",
            action: '/participante/' + id,
            token: token,
        }).then(response => {
            //extrai dados internos para o array principal
            var dadosRecebidos = extract({
                jsonLaravel: response.data.data,
                chaves: [
                    'enderecopais',
                    'aereomunicipioembarque',
                    'enderecomunicipio',
                    'banco',
                ]
            });

            //se estiver em alguma situação do grupo "confirmado" ou "declinaram", mostrar concluído
            var gruposSituacao = dadosRecebidos.grupoSituacao ?? [];
            if (gruposSituacao.includes("confirmados") || gruposSituacao.includes("declinaram")) {
                history.push({
                    pathname: "/cadastroEventoParticipanteConviteConcluido/" + dadosRecebidos.evento.id,
                    state: { idioma: dadosRecebidos.idioma }
                });
                return;
            }

            dadosRecebidos.evento.camposQuestionario = dadosRecebidos.evento.camposQuestionario ?
                JSON.parse(dadosRecebidos.evento.camposQuestionario) :
                {
                    "tipoparticipante": "sim",
                    "nome": "sim",
                    "assinaturaListaPresenca": "sim",
                    "telefone": "sim",
                    "email": "sim",
                    "especialidade": "sim",
                    "rg": "sim",
                    "crm": "sim",
                    "crmuf": "sim",
                    "datanascimento": "sim",
                    "cpf": "sim",
                    "enderecologradouro": "sim",
                    "endereconumero": "sim",
                    "enderecocomplemento": "sim",
                    "enderecocep": "sim",
                    "enderecobairro": "sim",
                    "enderecomunicipionome": "sim",
                    "enderecomunicipiouf": "sim",
                };

            delete dadosRecebidos.aereoidaobservacao;
            delete dadosRecebidos.aereoretornoobservacao;
            setDados(dadosRecebidos);
            setIsLoading(false);

            // Segunda chamada para buscar dados completos do evento (incluindo RSVP)
            if (dadosRecebidos.evento?.id) {
                api({
                    method: "get",
                    action: '/evento/' + dadosRecebidos.evento.id,
                    token: token,
                }).then(response => {
                    const dadosEvento = response.data.data;
                    if (dadosEvento) {
                        // Atualizar os dados do evento com as informações completas
                        setDados(prevDados => ({
                            ...prevDados,
                            evento: {
                                ...prevDados.evento,
                                nacionalidade: dadosEvento.nacionalidade,
                                documentosnecessariosentradapais: dadosEvento.evento_rsvp_data?.documentos_entrada_pais || ''
                            }
                        }));
                    }
                }).catch(err => {
                    console.log('Erro ao buscar dados do evento:', err);
                });
            }
        }).catch(err => {
            setIsLoading(false);
            setIsError(true);
            const message = idioma
                ? `${getText('error', idioma)} ${getText('errorLoadingDefault', idioma)}`
                : <>{getText('error', 'portugues')} {getText('errorLoadingDefault', 'portugues')}<br />({getText('error', 'ingles')} {getText('errorLoadingDefault', 'ingles')})</>;
            toast.error(message);
        });
    };//buscar

    const validar = async () => {
        const isInternacional = (dados.evento?.nacionalidade ?? "nacional") !== "nacional";
        const motivoIdaInformado = (dados.aereoidaobservacao ?? '').trim() !== '';
        const motivoVoltaInformado = (dados.aereoretornoobservacao ?? '').trim() !== '';

        if (isInternacional) {
            // Internacional: aceitar se selecionou voo OU se informou motivo sem selecionar
            const selecionouVoo = marcadoIda !== null && marcadoRetorno !== null;
            const semSelecaoComMotivo = !selecionouVoo && motivoIdaInformado;
            if (!selecionouVoo && !semSelecaoComMotivo) {
                toast.error(getText('informarMotivoIda', idioma));
                return false;
            }
        } else {
            // Nacional: regras originais
            if (!aereoNaoAtendeIda && marcadoIda === null) {
                toast.error(getText('escolherOpcaoIda', idioma));
                return false;
            }

            if (!aereoNaoAtendeVolta && marcadoRetorno === null) {
                toast.error(getText('escolherOpcaoVolta', idioma));
                return false;
            }

            if (aereoNaoAtendeIda && !motivoIdaInformado) {
                toast.error(getText('informarMotivoIda', idioma));
                return false;
            }

            if (aereoNaoAtendeVolta && !motivoVoltaInformado) {
                toast.error(getText('informarMotivoVolta', idioma));
                return false;
            }
        }

        if ((dados.evento?.camposQuestionario?.bagagemDespachada ?? "nao") === "sim") {
            var bagagemDespachada = document.querySelector("#bagagemDespachada");
            if ((dados.bagagemDespachada ?? '') === '') {
                toast.error(getText('preencherBagagem', idioma));
                setTimeout(() => {
                    bagagemDespachada.focus();
                }, 500);
                return false;
            }
        }

        // Validação para documentos de entrada no país (apenas para eventos internacionais)
        const isInternacionalDocumentos = (dados.evento?.nacionalidade ?? "nacional") !== "nacional";
        const temDocumentosEntradaPais = (dados.evento?.documentosnecessariosentradapais ?? '').trim() !== '';

        if (isInternacionalDocumentos && temDocumentosEntradaPais && !documentosEntradaPaisCiente) {
            toast.error('É necessário confirmar que está ciente dos documentos necessários para entrada no país');
            return false;
        }

        let confirmacao;

        const semSelecaoComMotivoInternacional = isInternacionalDocumentos && marcadoIda === null && motivoIdaInformado;

        if (aereoNaoAtendeIda || semSelecaoComMotivoInternacional) {
            confirmacao = await new Promise((resolve) => {
                Alert({
                    icon: "info",
                    confirmButton: <><FaThumbsUp size={20} /> OK</>,
                    confirmButtonColor: "success",
                    title: getText('atencao', idioma),
                    html: <>
                        <p>{getText('analisarSolicitacao', idioma)}</p>
                    </>,
                    callBack: (result) => {
                        resolve(result.isConfirmed);
                    }
                });
            });
        } else {
            const cidadeEmbarque = cidadeOrigem;
            confirmacao = await new Promise((resolve) => {
                Alert({
                    icon: "info",
                    confirmButton: <><FaThumbsUp size={20} /> {getText('confirmar', idioma)}</>,
                    cancelButton: getText('cancelar', idioma),
                    cancelButtonColor: "danger",
                    confirmButtonColor: "success",
                    title: getText('atencao', idioma),
                    html: <>
                        <p>{getText('confirmarAeroporto', idioma)} <strong>{cidadeEmbarque}</strong></p>
                        <p>{getText('opcaoVooEscolhida', idioma)}</p>
                    </>,
                    callBack: (result) => {
                        resolve(result.isConfirmed);
                    }
                });
            });
        }

        if (!confirmacao) {
            return false;
        }

        return true;
    };

    const salvar = async () => {
        var idEvento = dados.evento.id;

        if (!(await validar())) {
            return false;
        }

        setIsSubmitting(true);

        api({
            method: 'put',
            action: '/participante/escolhaAereo/' + id,
            token: token,
            data: {
                escolhaaereoida: marcadoIda,
                escolhaaereoretorno: marcadoRetorno,
                aereoidaobservacao: dados.aereoidaobservacao ?? null,
                aereoretornoobservacao: dados.aereoretornoobservacao ?? null,
                bagagemDespachada: dados.bagagemDespachada ?? null,
            }
        })
            .then(function (response) {
                if ((dados.transfer ?? 'nao') === "sim" || (dados.transferextra ?? 'nao') === "sim") {
                    history.push("/cadastroEventoParticipanteTransferConvite/" + id, { idioma: idioma });
                    return;
                }
                if ((dados.hotelhospedagem ?? 'nao') === "sim") {
                    history.push("/cadastroEventoParticipanteHotelConvite/" + id, { idioma: idioma });
                    return;
                }
                history.push("/cadastroEventoParticipanteConviteConcluido/" + idEvento, { idioma: idioma });
            })
            .catch(function (error) {
                toast.error(getText('errorSaving', getParticipantLanguage(dados)) + getText('errorSavingDefault', getParticipantLanguage(dados)));
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    }; //salvar

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate sidebar={['listarsvp', 'cliente'].includes(perfil) ? false : true} processando={isLoading} idioma={idioma ?? "both"}>
            <div className="main-content container-fluid">
                <div className="page-title">
                    <h3>{getText('escolhaAereo', idioma)}</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            {!isLoading && !isError && dados.evento?.id && <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                                {((dados.evento?.nacionalidade ?? "nacional") === "nacional") ? (
                                    <>
                                        <div className="card">
                                            <div className="card-content">
                                                <div className="card-body" style={{ padding: "0.5rem" }}>
                                                    <h4>{getText('ida', idioma)} <FaPlaneDeparture size={20} /></h4>
                                                    <div className="table-responsive">
                                                        <table className='table mb-0'>
                                                            <tbody>
                                                                <tr>
                                                                    <th></th>
                                                                    <th>{getText('data', idioma)}</th>
                                                                    <th>{getText('cia', idioma)}</th>
                                                                    <th>{getText('voo', idioma)}</th>
                                                                    <th>{getText('origem', idioma)}</th>
                                                                    <th>{getText('destino', idioma)}</th>
                                                                    <th>{getText('saida', idioma)}</th>
                                                                    <th>{getText('chegada', idioma)}</th>
                                                                </tr>
                                                                {dados.evento?.eventoaereo ? dados.evento.eventoaereo.map((row, rowIndex) => {
                                                                    return [
                                                                        <>
                                                                            <tr>
                                                                                <td width="5px">
                                                                                    <div className="form-check">
                                                                                        <div className="checkbox">
                                                                                            <label>
                                                                                                <input type="radio"
                                                                                                    name='idAereoIda'
                                                                                                    className="form-check-input"
                                                                                                    checked={dados.evento.eventoaereo[rowIndex].id === marcadoIda}
                                                                                                    onChange={(value) => {
                                                                                                        setMarcadoIda(dados.evento.eventoaereo[rowIndex].id);
                                                                                                        setCidadeOrigem(dados.evento.eventoaereo[rowIndex].idaorigem);
                                                                                                        setAereoNaoAtendeIda(false);
                                                                                                    }} />
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td>{(dados.evento.eventoaereo[rowIndex].idadata ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                                <td>{(dados.evento.eventoaereo[rowIndex].idacompanhia ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                                <td>{(dados.evento.eventoaereo[rowIndex].idavoo ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                                <td>{(dados.evento.eventoaereo[rowIndex].idaorigem ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                                <td>{(dados.evento.eventoaereo[rowIndex].idadestino ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                                <td>{(dados.evento.eventoaereo[rowIndex].idahorasaida ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                                <td>{(dados.evento.eventoaereo[rowIndex].idahorachegada ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                            </tr>
                                                                        </>
                                                                    ];
                                                                }) : null}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-sm-12">
                                                            <div className="form-check">
                                                                <div className="checkbox">
                                                                    <label>
                                                                        <input type="radio"
                                                                            name='idAereoIda'
                                                                            className="form-check-input"
                                                                            checked={aereoNaoAtendeIda}
                                                                            onChange={(e) => {
                                                                                setAereoNaoAtendeIda(true);
                                                                                setMarcadoIda(null);
                                                                            }} />
                                                                        {getText('aereoNaoAtende', idioma)}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {aereoNaoAtendeIda && (
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <div className="form-group">
                                                                    <textarea
                                                                        className="form-control form-control-lg"
                                                                        id="aereoidaobservacao"
                                                                        placeholder={getText('motivoAereoIda', idioma)}
                                                                        style={{ minHeight: "100px" }}
                                                                        value={dados.aereoidaobservacao}
                                                                        onChange={e => {
                                                                            setDados({ ...dados, ...{ "aereoidaobservacao": e.target.value } });
                                                                            if (e.target.value.length > 0) {
                                                                                setMarcadoIda(null);
                                                                            }
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card">
                                            <div className="card-content">
                                                <div className="card-body" style={{ padding: "0.5rem" }}>
                                                    <h4>{getText('volta', idioma)} <FaPlaneArrival size={20} /></h4>
                                                    <div className="table-responsive">
                                                        <table className='table mb-0'>
                                                            <tbody>
                                                                <tr>
                                                                    <th></th>
                                                                    <th>{getText('data', idioma)}</th>
                                                                    <th>{getText('cia', idioma)}</th>
                                                                    <th>{getText('voo', idioma)}</th>
                                                                    <th>{getText('origem', idioma)}</th>
                                                                    <th>{getText('destino', idioma)}</th>
                                                                    <th>{getText('saida', idioma)}</th>
                                                                    <th>{getText('chegada', idioma)}</th>
                                                                </tr>
                                                                {dados.evento?.eventoaereo ? dados.evento.eventoaereo.map((row, rowIndex) => {
                                                                    return [
                                                                        <>
                                                                            <tr>
                                                                                <td width="5px">
                                                                                    <div className="form-check">
                                                                                        <div className="checkbox">
                                                                                            <label>
                                                                                                <input type="radio"
                                                                                                    name='idAereoRetorno'
                                                                                                    className="form-check-input"
                                                                                                    checked={dados.evento.eventoaereo[rowIndex].id === marcadoRetorno}
                                                                                                    onChange={(value) => {
                                                                                                        setMarcadoRetorno(dados.evento.eventoaereo[rowIndex].id);
                                                                                                        setAereoNaoAtendeVolta(false);
                                                                                                    }} />
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td>{(dados.evento.eventoaereo[rowIndex].retornodata ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                                <td>{(dados.evento.eventoaereo[rowIndex].retornocompanhia ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                                <td>{(dados.evento.eventoaereo[rowIndex].retornovoo ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                                <td>{(dados.evento.eventoaereo[rowIndex].retornoorigem ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                                <td>{(dados.evento.eventoaereo[rowIndex].retornodestino ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                                <td>{(dados.evento.eventoaereo[rowIndex].retornohorasaida ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                                <td>{(dados.evento.eventoaereo[rowIndex].retornohorachegada ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                            </tr>
                                                                        </>
                                                                    ];
                                                                }) : null}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-sm-12">
                                                            <div className="form-check">
                                                                <div className="checkbox">
                                                                    <label>
                                                                        <input type="radio"
                                                                            name='idAereoRetorno'
                                                                            className="form-check-input"
                                                                            checked={aereoNaoAtendeVolta}
                                                                            onChange={(e) => {
                                                                                setAereoNaoAtendeVolta(true);
                                                                                setMarcadoRetorno(null);
                                                                            }} />
                                                                        {getText('aereoNaoAtende', idioma)}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {aereoNaoAtendeVolta && (
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <div className="form-group">
                                                                    <textarea
                                                                        className="form-control form-control-lg"
                                                                        id="aereoretornoobservacao"
                                                                        placeholder={getText('motivoAereoVolta', idioma)}
                                                                        style={{ minHeight: "100px" }}
                                                                        value={dados.aereoretornoobservacao}
                                                                        onChange={e => {
                                                                            setDados({ ...dados, ...{ "aereoretornoobservacao": e.target.value } });
                                                                            if (e.target.value.length > 0) {
                                                                                setMarcadoRetorno(null);
                                                                            }
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div className="card">
                                        <div className="card-content">
                                            <div className="card-body" style={{ padding: "0.5rem" }}>
                                                <div className="table-responsive">
                                                    <table className='table mb-0'>
                                                        <tbody>
                                                            <tr>
                                                                <th></th>
                                                                <th></th>
                                                                <th>{getText('data', idioma)}</th>
                                                                <th>{getText('cia', idioma)}</th>
                                                                <th>{getText('voo', idioma)}</th>
                                                                <th>{getText('origem', idioma)}</th>
                                                                <th>{getText('destino', idioma)}</th>
                                                                <th>{getText('saida', idioma)}</th>
                                                                <th>{getText('chegada', idioma)}</th>
                                                            </tr>
                                                            {dados.evento?.eventoaereo ? dados.evento.eventoaereo.map((row, rowIndex) => {
                                                                return [
                                                                    <>
                                                                        <tr className='lenteCinza'>
                                                                            <td width="5px" rowSpan={2}>
                                                                                <div className="form-check">
                                                                                    <div className="checkbox">
                                                                                        <label>
                                                                                            <input type="radio"
                                                                                                name='idAereoIda'
                                                                                                className="form-check-input"
                                                                                                checked={dados.evento.eventoaereo[rowIndex].id === marcadoIda}
                                                                                                onChange={(value) => {
                                                                                                    setMarcadoRetorno(dados.evento.eventoaereo[rowIndex].id);
                                                                                                    setMarcadoIda(dados.evento.eventoaereo[rowIndex].id);
                                                                                                }} />
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td>{getText('ida', idioma)}</td>
                                                                            <td>{(dados.evento.eventoaereo[rowIndex].idadata ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                            <td>{(dados.evento.eventoaereo[rowIndex].idacompanhia ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                            <td>{(dados.evento.eventoaereo[rowIndex].idavoo ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                            <td>{(dados.evento.eventoaereo[rowIndex].idaorigem ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                            <td>{(dados.evento.eventoaereo[rowIndex].idadestino ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                            <td>{(dados.evento.eventoaereo[rowIndex].idahorasaida ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                            <td>{(dados.evento.eventoaereo[rowIndex].idahorachegada ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                        </tr>
                                                                        <tr className='lenteCinza'>
                                                                            <td width="5px">
                                                                                {getText('retorno', idioma)}
                                                                            </td>
                                                                            <td>{(dados.evento.eventoaereo[rowIndex].retornodata ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                            <td>{(dados.evento.eventoaereo[rowIndex].retornocompanhia ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                            <td>{(dados.evento.eventoaereo[rowIndex].retornovoo ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                            <td>{(dados.evento.eventoaereo[rowIndex].retornoorigem ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                            <td>{(dados.evento.eventoaereo[rowIndex].retornodestino ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                            <td>{(dados.evento.eventoaereo[rowIndex].retornohorasaida ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                            <td>{(dados.evento.eventoaereo[rowIndex].retornohorachegada ?? '').split("|").map((valor) => { return (<>{valor}<br /></>); })}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th colSpan={9}></th>
                                                                        </tr>
                                                                    </>
                                                                ];
                                                            }) : null}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <label>{getText('opcaoVooNaoAtende', idioma)}</label>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <div className="form-group">
                                                            <textarea
                                                                className="form-control form-control-lg"
                                                                id="aereoidaobservacao"
                                                                placeholder={getText('motivo', idioma)}
                                                                style={{ minHeight: "100px" }}
                                                                value={dados.aereoidaobservacao}
                                                                onChange={e => {
                                                                    setDados({ ...dados, ...{ "aereoidaobservacao": e.target.value } });
                                                                    if (e.target.value.length > 0) {
                                                                        setMarcadoIda(null);
                                                                        setMarcadoRetorno(null);
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {(dados.evento?.camposQuestionario?.bagagemDespachada ?? "nao") === "sim" ?
                                    <div className="card">
                                        <div className="card-content">
                                            <div className="card-body" style={{ padding: "0.5rem" }}>
                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        <div className="form-group">
                                                            <label>{getText('necessitaBagagem', idioma)}</label>
                                                            <ReactSelect
                                                                id={"bagagemDespachada"}
                                                                value={{ value: dados.bagagemDespachada, label: dados.nomeBagagemDespachada }}
                                                                onChange={e => setDados({ ...dados, ...{ "bagagemDespachada": e.value, "nomeBagagemDespachada": e.label } })}
                                                                options={[
                                                                    { value: "nao", label: getText('nao', idioma) },
                                                                    { value: "sim", label: getText('sim', idioma) },
                                                                ]}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : null}
                                <div className="card">
                                    <div className="card-content">
                                        <div className="card-body" style={{ padding: "0.5rem" }}>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <h4>{getText('informacoesImportantesAereo', idioma)}</h4>
                                                    <p>
                                                        {getText('opcaoAereoEmissao', idioma)}
                                                    </p>
                                                    <p>
                                                        <div style={{ fontStyle: 'italic' }}>{getText('documentacaoObrigatoria', idioma)}</div>
                                                        {((dados.evento?.nacionalidade ?? "nacional") === 'nacional') ?
                                                            <strong>{getText('documentoNacional', idioma)}</strong>
                                                            :
                                                            <strong>
                                                                {getText('documentoInternacional', idioma)}<br />
                                                                {getText('enviarCopiaDocumento', idioma)} {dados.evento?.emailremetente ?? ""}
                                                            </strong>
                                                        }
                                                    </p>
                                                    <p>
                                                        A {dados.evento?.cliente?.nomefantasia} {getText('responsabilidadePatrocinio', idioma)}<br />
                                                        {getText('alteracoesResponsabilidade', idioma)}
                                                    </p>
                                                    <p>
                                                        {getText('confirmarNomeDocumento', idioma)}<br />
                                                        {getText('informacaoImportante', idioma)}<br />
                                                        {getText('observacoesImportantes', idioma)}<br />
                                                        {getText('alteracaoAposEmissao', idioma)}
                                                        {isSanofiModelo && (
                                                            <>
                                                                <br />
                                                                {getText('despesasAcompanhanteResponsabilidade', idioma)}<br />
                                                                {getText('assinaturaSanofi', idioma)}
                                                            </>
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Seção de documentos necessários para entrada no país - apenas para eventos internacionais */}
                                {((dados.evento?.nacionalidade ?? "nacional") === "internacional" && (dados.evento?.documentosnecessariosentradapais ?? '').trim() !== '') && (
                                    <div className="card">
                                        <div className="card-content">
                                            <div className="card-body" style={{ padding: "0.5rem" }}>
                                                <h4>Documentos necessários para entrada no país</h4>
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <div className="alert alert-info">
                                                            <p style={{ whiteSpace: 'pre-line' }}>
                                                                {dados.evento.documentosnecessariosentradapais}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <div className="form-check">
                                                            <div className="checkbox">
                                                                <label>
                                                                    <input type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={documentosEntradaPaisCiente}
                                                                        onChange={(e) => setDocumentosEntradaPaisCiente(e.target.checked)} />
                                                                    Estou ciente dos documentos necessários para entrada no país
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="card">
                                    <div className="card-content">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-12 d-flex justify-content-end">
                                                    <button type="submit" className="btn btn-primary me-1 mb-1" disabled={isSubmitting}>
                                                        <FaSave size={20} /> {getText('salvar', idioma)}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>}
                        </div>
                    </div>
                </section>
            </div >
        </ErpTemplate >
    );
}